
interface ServerApiError {
  error: string;
  code: string;
  full: string;
  data?: any;
}
class ApiError extends Error {
  serverStack: string;
  data?: any;
  originalMessage: string;
  constructor(originalError: ServerApiError, customMessage?: string) {
    super(customMessage || originalError.error);
    this.originalMessage = originalError.error;
    this.name = originalError.code;
    this.serverStack = originalError.full;
    this.data = originalError.data;
  }
}

class MongoUniqueError extends ApiError {
  invalidFields: string[];
  constructor(originalError: ServerApiError) {
    let message = "Another resource matching the following unique fields already exists: \n";
    for (let [k, v] of Object.entries(originalError.data.keyValue || {}))
      message += ` - ${k}: ${JSON.stringify(v)}\n`;

    super(originalError, message.trim());
    this.invalidFields = Object.keys(originalError.data.keyValue);

  }
}
class ValidationFailError extends ApiError {
  invalidFields: string[];
  constructor(originalError: ServerApiError) {
    const issues = Array.isArray(originalError.data) ? originalError.data : [];
    const parts = issues.map((r: any) => {
      let msg = String(r.message || "Invalid input");
      if (r.validation == "regex") msg = "wasn't in the expected format";
      msg = msg.replace(/^validateProperties:\s*/i, "");
      const path = Array.isArray(r.path)
        ? r.path.filter((p: unknown) => p !== undefined && p !== null && `${p}` !== "").join(".")
        : "";
      return { path, msg };
    });

    // Full-sentence guidance (e.g. "Please set...") — show as the error text, not a schema dump.
    const guidanceOnly = parts.length > 0 && parts.every((p) => /^please\b/i.test(p.msg));
    const message = guidanceOnly
      ? parts.map((p) => p.msg).filter((msg, i, arr) => arr.indexOf(msg) === i).join("\n")
      : (
          "The data provided did not pass validation: \n" +
          parts.map((p) => (p.path ? ` - ${p.path}: ${p.msg}` : ` - ${p.msg}`)).join("\n")
        ).trim();

    super(originalError, message);
    this.invalidFields = parts.map((p) => p.path).filter(Boolean);
  }
}

function getError(response: string) {
  let json;
  try {
    json = JSON.parse(response);
  } finally{}
  if (!json || !json.error) return new Error(response);
  switch (json.code) {
    case "MONGO_11000":
      return new MongoUniqueError(json);
    case "SCHEMA_VALIDATION_FAILED":
      return new ValidationFailError(json);
    default:
      return new ApiError(json);
  }
}
export async function checkError(res: Response) {
  if (!res.ok) throw getError(await res.text());
  else return res;
}
